<template>
  <div>
    <modal :show.sync="modals.modal1" type="medium">
      <div
        style="background-color: #f5f6fa; padding: 20px; border-radius: 20px"
      >
        <div slot="header" class="modal-title" id="modal-title-default">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-11">
                <p
                  style="
                    color: #358CCB;
                    text-align: left;
                    font-size: 24px;
                    font-weight: 300;
                  "
                >
                  Tunas Holdings
                </p>
              </div>
              <div class="col-lg text-right">
                <div
                  style="
                    position: relative;
                    height: 25px;
                    width: 25px;
                    left: 50px;
                    background-color: #ea2127;
                    border-radius: 100px;
                    cursor: pointer;
                  "
                >
                  <i
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    "
                    class="tim-icons icon-simple-remove"
                    @click="closeModal()"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12" style="padding: 10px">
          <div class="row">
            <div class="col-lg-6" v-for="(card, index) in pics" :key="index">
              <b-card
                class="card"
                border-variant="primary"
                :header="getPICTitle(index)"
                header-bg-variant="primary"
                header-text-variant="white"
                style="box-shadow: 0px 0px; border: none"
              >
                <div>
                  <p
                    style="
                      text-align: left;
                      font-size: 15px;
                      color: #A5A5A5;
                      opacity: 0.7;
                    "
                  >
                    PIC Name
                  </p>
                  <p
                    style="
                      font-size: 17px;
                      color: #5a5a5a;
                      opacity: 0.78;
                      text-align: left;
                      font-weight: 600;
                      font-size: 18px;
                      margin-top: -10px;
                    "
                  >
                    {{ namee }}
                  </p>
                  <p
                    style="
                      text-align: left;
                      font-size: 15px;
                      color: #A5A5A5;
                      opacity: 0.7;
                    "
                  >
                    PIC Phone No.
                  </p>
                  <p
                    style="
                      font-size: 17px;
                      color: #5a5a5a;
                      opacity: 0.78;
                      text-align: left;
                      font-weight: 600;
                      font-size: 18px;
                      margin-top: -10px;
                    "
                  >
                    {{ pics[index].phoneno }}
                  </p>

                  <p
                    style="
                      text-align: left;
                      font-size: 15px;
                      color: #A5A5A5;
                      opacity: 0.7;
                    "
                  >
                    Email
                  </p>
                  <p
                    style="
                      font-size: 17px;
                      color: #5a5a5a;
                      opacity: 0.78;
                      text-align: left;
                      font-weight: 600;
                      font-size: 18px;
                      margin-top: -10px;
                    "
                  >
                    {{ pics[index].email }}
                  </p>
                </div>
              </b-card>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <p
            style="
              color: #358CCB;
              text-align: left;
              font-size: 24px;
              font-weight: 300;
            "
          >
            Uploaded Files
          </p>
          <p style="text-align: left; font-size: 15px; color: #A5A5A5">
            Tunas Holding SSM.pdf
          </p>
        </div>

        <div
          v-if="!hidden"
          class="col-lg-12"
          style="margin-bottom: 30px; text-align: right"
        >
          <base-button type="cancel" v-on:click="getDecline()"
            >Decline</base-button
          >&nbsp;
          <base-button type="primary" v-on:click="getApprove()"
            >Approve</base-button
          >
        </div>

        <div v-if="decline" class="col-lg-12">
          <p
            style="
              color: #358CCB;
              text-align: left;
              font-size: 24px;
              font-weight: 300;
            "
          >
            Comment Section
          </p>
          <p
            style="
              text-align: left;
              font-size: 15px;
              margin-top: -10px;
              color: #A5A5A5;
            "
          >
            Please add your remarks for rejection
          </p>
          <textarea
            type="textarea"
            placeholder="Write your commment..."
            v-model="reason"
            :class="{ 'custom-input-2': true }"
          ></textarea>
          <div class="col-lg-12" style="margin-bottom: 30px; text-align: right">
            <base-button type="danger" v-on:click="closeModal()"
              >Back</base-button
            >&nbsp;
            <base-button type="primary" v-on:click="getReason()"
              >Submit</base-button
            >
          </div>
        </div>
      </div>
    </modal>
    <modal :show.sync="modals.warningModal">
      <div
        class="modal-header"
        style="
          margin: -25px -24px 0px -24px;
          padding: 20px 40px 20px 40px;
          background-color: #e5c513;
        "
      >
        <div class="col-lg"></div>
        <div class="col-lg-5">
          <div
            style="
              padding: 15px;
              background-color: transparent;
              border-radius: 100px;
              border: 10px solid white;
              text-align: center;
            "
          >
            <i
              style="color: white; font-size: 90px; font-weight: 900"
              class="fa fa-exclamation"
            ></i>
          </div>
          <div>
            <p
              style="
                color: white;
                font-size: 17px;
                text-align: center;
                font-weight: 500;
              "
            >
              Warning
            </p>
          </div>
        </div>
        <div class="col-lg"></div>
      </div>
      <div class="col-lg-12 text-center">
        <p
          style="
            margin-top: 50px;
            font-size: 40px;
            font-weight: 500;
            color: #707070;
          "
        >
          Are you sure?
        </p>

        <p style="color: #A5A5A5">You won't be able to revert this!</p>

        <p style="color: #A5A5A5; margin-top: 20px">
          Click 'Continue' to proceed to login page
        </p>
        <div class="col-lg-12 text-center" style="margin-bottom: 50px">
          <base-button class="btn-cancel" v-on:click="cancelContractor()"
            >Cancel</base-button
          >
          <base-button type="primary" v-on:click="deleteContractor()"
            >Continue</base-button
          >
        </div>
      </div>
    </modal>
    <modal :show.sync="modals.removeModal">
      <div
        class="modal-header"
        style="
          margin: -25px -24px 0px -24px;
          padding: 20px 40px 20px 40px;
          background-color: #15cf79;
        "
      >
        <div class="col-lg"></div>
        <div class="col-lg-5">
          <div
            style="
              padding: 15px;
              background-color: transparent;
              border-radius: 100px;
              border: 10px solid white;
            "
          >
            <i
              style="color: white; font-size: 90px; font-weight: 900"
              class="tim-icons icon-check-2"
            ></i>
          </div>
          <div>
            <p
              style="
                color: white;
                font-size: 17px;
                text-align: center;
                font-weight: 500;
              "
            >
              Successful
            </p>
          </div>
        </div>
        <div class="col-lg"></div>
      </div>
      <div class="col-lg-12 text-center">
        <p
          style="
            margin-top: 50px;
            font-size: 40px;
            font-weight: 500;
            color: #707070;
          "
        >
          Remove File!
        </p>

        <p style="color: #A5A5A5">{{ message }}</p>

        <div class="col-lg-12 text-center" style="margin-bottom: 50px">
          <base-button type="primary" v-on:click="modals.removeModal = false"
            >Okay</base-button
          >
        </div>
      </div>
    </modal>

    <div
      class="col-lg-12"
      style="padding-top: 20px; padding-bottom: 20px"
    ></div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <!-- <base-input> -->
          <el-input
            type="search"
            class="mb-3 search-input"
            prefix-icon="el-icon-search"
            placeholder="Search..."
            v-model="searchQuery"
            aria-controls="datatables"
          ></el-input>
          <!-- </base-input> -->
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div id="tableku" v-if="this.load == false">
            <el-table
              :data="queriedData"
              style="width: 100%"
              height="600"
              :header-cell-style="{
                background: 'transparent',
                color: 'gray',
              }"
              class="custom-table"
            >
              <el-table-column
                :min-width="50"
                align="center"
                prop="index"
                label="NO"
              >
              </el-table-column>
              <el-table-column
                :min-width="200"
                align="center"
                prop="staffid"
                label="ID"
              ></el-table-column>
              <el-table-column
                :min-width="200"
                align="center"
                prop="name"
                label="NAME"
              ></el-table-column>
              <el-table-column
                :min-width="200"
                align="center"
                prop="phone"
                label="PHONE NO."
              ></el-table-column>
              <el-table-column
                :min-width="200"
                align="center"
                prop="servicelocation"
                label="SERVICE LOCATION"
              >
              <div slot-scope="{ row }">
                  <p style="color: #A5A5A5; word-break: break-word">
                    {{ row.servicelocation }}
                  </p>
                </div></el-table-column>
              <!--  <el-table-column
                :min-width="200"
                align="center"
                prop="companyname"
                label="Company Name"
              >
                <div slot-scope="{ row }">
                  <p class="link" @click="getModal(row)">
                    {{ row.companyname }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column
                :min-width="200"
                align="center"
                prop="companyregno"
                label="Company Reg. No."
              ></el-table-column>
              <el-table-column
                :min-width="200"
                align="center"
                prop="usertype"
                label="User Type"
              ></el-table-column>
              <el-table-column
                :min-width="200"
                align="center"
                prop="companyaddress"
                label="Company Address"
              ></el-table-column>
              <el-table-column
                :min-width="200"
                align="center"
                prop="officetelno"
                label="Office Tel No. / Fax No."
              ></el-table-column> -->

              <el-table-column
                v-if="accessid == 2"
                :min-width="100"
                align="center"
                label="VIEW"
              >
                <div slot-scope="{ row }">
                  <i
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: #A5A5A5;
                      font-size: 15px;
                      font-weight: 900;
                      cursor: pointer;
                    "
                    @click="getEdit(row.id, 'preview')"
                    class="fa fa-file"
                  ></i>
                </div>
              </el-table-column>
              <el-table-column
                v-if="accessid != 2"
                :min-width="100"
                align="center"
                prop="edit"
                label="EDIT"
              >
                <div slot-scope="{ row }">
                  <i
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: #A5A5A5;
                      font-size: 15px;
                      font-weight: 900;
                      cursor: pointer;
                    "
                    @click="getEdit(row.id, 'edit')"
                    class="tim-icons icon-pencil"
                  ></i>
                </div>
              </el-table-column>

              <el-table-column
                v-if="accessid != 2"
                :min-width="100"
                align="center"
                prop="archive"
                label="ARCHIVE"
              >
                <div slot-scope="{ row }">
                  <i
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: #A5A5A5;
                      font-size: 15px;
                      font-weight: 900;
                      cursor: pointer;
                    "
                    @click="getArchive(row.id)"
                    class="tim-icons icon-check-2"
                  ></i>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div class="d-flex justify-content-center spinner" v-if="load">
            <circle-8></circle-8>
          </div>
          <!-- </card> -->
          <div
            style="padding-top: 80px"
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <!-- <base-input> -->
            <el-select
              v-model="pagination.perPage"
              placeholder="Per page"
              style="border-radius: 10px"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <!-- </base-input> -->
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import Card from "../../../../components/Cards/Card.vue";
import { BCard } from "bootstrap-vue";

import {
  Modal,
  ImageUpload,
  BasePagination,
  BaseSwitch,
} from "../../../../../src/components";
import moment from "moment";
import Fuse from "fuse.js";
import { debounce } from "src/util/debounce";

export default {
  name: "CustLand",
  props: {
    tot: {
      type: Function,
    },
  },
  components: {
    BCard,
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      accessid: "",
      message: "",
      namee: "",
      id: 0,
      approvalstatus: 0,

      hidden: false,
      decline: false,
      reason: "",

      pics: [
        {
          name: "Haziq Haikal bin Ayub",
          phoneno: "+60195627890",
          email: "haziq@tunas.com.my",
        },
        {
          name: "Aida Yasmin Yazli",
          phoneno: "+60182297789",
          email: "aida@tunas.com.my",
        },
      ],
      cardPICCount: 2,

      modals: {
        modal1: false,
        modal2: false,
        warningModal: false,
        removeModal: false,
      },
      selectedFileName: "",
      allfilename: [],
      tableDatas: [],

      load: false,

      authorities: [
        // {
        //   prop: "datereg",
        //   label: "DATE REG.",
        // },
        // {
        //   prop: "agencyname",
        //   label: "AGENCY NAME",
        // },
        // {
        //   prop: "usertype",
        //   label: "USER TYPE",
        // },
        // {
        //   prop: "position",
        //   label: "POSITION",
        // },
        {
          prop: "telno",
          label: "OFFICE TEL NO. / FAX NO",
        },
      ],

      selects: {
        assigner: "",
        assigners: [
          { value: "00", label: "All" },
          { value: "01", label: "Yahya Abd Rahman" },
          { value: "02", label: "Ikhwan Ayub" },
          { value: "03", label: "Haziq Haikal" },
        ],
      },

      temp: [],
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 30, 50],
        total: 0,
      },
      deletedcontractorid: "",
    };
  },
  methods: {
    cancelContractor() {
      this.modals.warningModal = false;
      this.deletedcontractorid = "";
    },
    getArchive(contractorid) {
      this.deletedcontractorid = contractorid;
      //   console.log(contractorid);
      this.modals.warningModal = true;
    },
    deleteContractor() {
      console.log(this.deletedcontractorid);
      this.$http
        .delete(
          ":10001/api/v1/user-management/personnel/" + this.deletedcontractorid
        )
        .then((res) => {
          if (!res.error) {
            this.modals.warningModal = false;
            let response = res.message;
            console.log(response);
            this.getData();
            this.message = response;
            this.modals.removeModal = true;
          }
        });
    },
    getEdit(id, flag) {
      console.log(id);
      this.$router.push("/AddContractor/" + id + "/" + flag);
      //create new page
    },
    // handleRowClick(row, column, event) {
    //   this.getModal(row);
    // },
    getPICTitle(index) {
      return `PIC - ${index + 1}`;
    },
    getModal(data) {
      this.namee = data.agencyname;
      this.id = data.id;
      this.approvalstatus = data.approvalstatus;
      this.modals.modal1 = true;
      this.checkStatus();
    },
    closeModal() {
      this.modals.modal1 = false;
    },
    getJobPage() {
      this.$router.push("/JobPage1");
    },

    checkStatus() {
      if (this.approvalstatus == 2) {
        this.hidden = true;
        this.decline = false;
      } else if (this.approvalstatus == 3) {
        this.hidden = true;
        this.decline = true;
        //if dah submit this.decline = false;
      } else {
        this.hidden = false;
        this.decline = false;
      }
    },

    getApprove() {
      let obj = {
        status: 2,
      };
      console.log(this.approvalstatus);
      this.$http
        .put(":10001/api/v1/user-management/authority/" + this.id, obj)
        .then((res) => {
          console.log(res);
          this.modals.modal1 = false;
          this.tableDatas.forEach((data) => {
            if (data.id === this.id) {
              data.approvalstatus = 2;
            }
          });
        });
    },

    getDecline() {
      let obj = {
        status: 3,
      };
      this.$http
        .put(":10001/api/v1/user-management/authority/" + this.id, obj)
        .then((res) => {
          console.log(res);
          this.tableDatas.forEach((data) => {
            if (data.id === this.id) {
              data.approvalstatus = 3;
            }
          });
          this.decline = true;
          this.hidden = true;
        });
    },

    getReason() {
      //emailkan ke customer the reasons
      this.decline = false;
    },

    getData() {
      this.load = true;
      this.tableDatas = [];

      this.$http.get(":10001/api/v1/user-management/personnel").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          let count = 0;
          for (var i = 0; i < response.length; i++) {
            if (response[i].approval_status == 1) {
              count++;
            }
            let obj = {
              index:
                i +
                1 +
                this.pagination.perPage * (this.pagination.currentPage - 1),
              name: response[i].personnel_name,
              phone: response[i].personnel_phone_number,
              id: response[i].personnel_id,
              staffid: response[i].personnel_staff_id,
              servicelocation: response[i].service_location,

              // datereg: moment(response[i].created_at).format("YYYY-MM-DD"),
              // companyname: response[i].contractor_name,
              // companyregno: response[i].contractor_registration_no,
              // usertype: "Contractor",
              // companyaddress: response[i].contractor_address,
              // officetelno: response[i].contractor_phone_number,
              // companyid: response[i].contractor_id,
            };
            this.tableDatas.push(obj);
            this.temp.push(obj);
          }
          this.tot("Execution Team", count, this.accessid);
        }
        this.load = false;
      });
    },
  },
  created() {
    this.accessid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );

    this.getData();
  },
  computed: {
    queriedData() {
      let result = this.tableDatas;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDatas.length;
    },
  },
  watch: {
    searchQuery: debounce(function (search) {
      console.log(search);
      if (search != "") {
        this.tableDatas = this.temp.filter(
          (value) =>
            value.name.toLowerCase().includes(search.toLowerCase()) ||
            value.phone.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.tableDatas = this.temp;
      }
    }, 500),
  },
  mounted() {
    this.fuseSearch = new Fuse(this.tableDatas, {
      keys: ["jobno"],
      threshold: 1.0,
    });
  },
};
</script>
<style scoped>
.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.custom-dropdown .el-select-dropdown {
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card .card-header {
  text-transform: uppercase;
  font-weight: 600;
  padding-bottom: 10px;
  font-size: 18px;
}

.custom-input-2 {
  margin: 5px 5px 15px 5px;
  border-radius: 10px;
  background-color: transparent;
  border: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

.link {
  cursor: pointer;
  color: #9b9b9b;
}
.link:hover {
  text-decoration: underline;
  cursor: pointer;
  color: #368dcc;
}
</style>
